import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';
import QuestionnaireForm from '../components/QuestionnaireForm';
import { EMPTY_QUESTIONNAIRE, questionnaireFromApi } from '../questionnaire/options';

function firstError(data) {
  if (!data || typeof data !== 'object') return 'Не удалось сохранить анкету';
  if (typeof data.detail === 'string') return data.detail;
  const first = Object.entries(data)[0];
  if (!first) return 'Не удалось сохранить анкету';
  const [key, val] = first;
  return `${key}: ${Array.isArray(val) ? val[0] : val}`;
}

export default function QuestionnairePage() {
  const { refreshUser } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const fromRegister = searchParams.get('from') === 'register';

  const [form, setForm] = useState(EMPTY_QUESTIONNAIRE);
  const [filled, setFilled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      setError('');
      try {
        const res = await api.get('/auth/questionnaire/');
        if (cancelled) return;
        setFilled(!!res.data?.filled);
        setForm(questionnaireFromApi(res.data));
      } catch {
        if (!cancelled) setError('Не удалось загрузить анкету');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');
    try {
      const res = await api.put('/auth/questionnaire/', form);
      setFilled(true);
      setForm(questionnaireFromApi(res.data));
      await refreshUser();
      setSuccess('Анкета сохранена');
      if (fromRegister) {
        navigate('/dashboard', { replace: true });
      }
    } catch (err) {
      setError(firstError(err.response?.data));
    } finally {
      setSaving(false);
    }
  }

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Загрузка анкеты...</p>
      </div>
    );
  }

  return (
    <div className="questionnaire-page">
      <div className="page-header">
        <h1>{filled ? 'Анкета' : 'Анкета ученика'}</h1>
        <p className="page-subtitle">
          {fromRegister
            ? 'После регистрации полезно заполнить короткую анкету — от неё зависит режим занятий и объём ДЗ. Можно заполнить сейчас или позже в профиле.'
            : 'Можно менять ответы в любой момент. Преподаватель видит актуальную версию.'}
        </p>
      </div>

      <QuestionnaireForm
        form={form}
        onChange={setForm}
        onSubmit={handleSubmit}
        saving={saving}
        error={error}
        success={success}
        submitLabel={filled ? 'Сохранить изменения' : 'Отправить анкету'}
        extraActions={
          fromRegister ? (
            <button
              type="button"
              className="btn btn-outline"
              onClick={() => navigate('/dashboard', { replace: true })}
            >
              Заполнить позже
            </button>
          ) : (
            <Link to="/profile" className="btn btn-outline">
              К профилю
            </Link>
          )
        }
      />
    </div>
  );
}
